export default "__VITE_ASSET__DhyxmUhL__"